




















































import { Component, Vue } from 'vue-property-decorator';
import { ICart } from '@/models/CartModels';

import CartsMenuItem from './components/CartsMenuItem.vue';

@Component({
  components: {
    CartsMenuItem,
  },
})
export default class App extends Vue {
  public drawer: boolean = false;
  public goTo(to: string) {
    this.$router.push({ name: to, replace: true });
  }

  get carts(): ICart[] {
    return this.$store.getters['carts/carts'];
  }
}
